<template>
  <ClientOnly><SplashBanner /></ClientOnly>
  <HorizontalBanner />
  <!-- Brochures -->
  <BrochuresGrid
    :input="{}"
    :pagination="{ limit: 10, offset: 0 }"
    :title="$t('home.new-brochures-this-week')"
    :impression-source="BrochureImpressionSource.NewOpen"
    class="full-rows-only"
    tag="h2"
  >
    <template #content>
      <DynamicContent
        id="content-block-0"
        :html="content?.introductionBlock"
        :style="{ padding: 0 }"
        :variant="'narrow'"
      ></DynamicContent>
    </template>
  </BrochuresGrid>
  <CenteredContent class="mt-3 mb-3">
    <BaseButton @click.prevent="loadMoreBrochures">{{ $t("home.more-brochures") }}</BaseButton>
  </CenteredContent>

  <!-- Ad -->
  <Advertisement :display-at="AdDisplayAt.HomepageTop" class="ad" />

  <!-- Shops -->
  <ShopsGrid :pagination="{ limit: 10, offset: 0 }" :title="$t('home.recommended-shops')" tag="h2">
    <template #content>
      <DynamicContent
        id="content-block-1"
        :html="content?.similarBlock"
        :style="{ padding: 0 }"
        :variant="'narrow'"
      ></DynamicContent>
    </template>
  </ShopsGrid>
  <CenteredContent class="mt-3 mb-3">
    <BaseButtonLink to="shops">{{ $t("home.all-shops") }}</BaseButtonLink>
  </CenteredContent>

  <!-- Ad -->
  <Advertisement :display-at="AdDisplayAt.HomepageBottom" class="ad" />

  <!-- Offers -->
  <OffersGrid :pagination="{ limit: 8, offset: 0 }" :title="$t('home.recommended-offers')" class="mb-3" tag="h2">
    <template #content>
      <DynamicContent
        id="content-block-2"
        :html="content?.timedBlock"
        :style="{ padding: 0 }"
        :variant="'narrow'"
      ></DynamicContent>
    </template>
  </OffersGrid>
  <CenteredContent class="mb-3">
    <BaseButtonLink to="offers">{{ $t("home.all-offers") }}</BaseButtonLink>
  </CenteredContent>

  <!-- Mailinglist -->

  <!-- App banner -->
  <DownloadAppBanner />
  <div class="content-wrapper">
    <div class="container">
      <DynamicContent
        id="content-block-3"
        :html="content?.offersBlock"
        :style="{ padding: 0 }"
        :variant="'wide'"
      ></DynamicContent>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AdDisplayAt, BrochureImpressionSource, useWebsitePageQuery } from "~/graphql/generated";

// Navigate to the new page and scroll to the current position
const loadMoreBrochures = () => {
  const router = useRouter();
  const localePath = useLocalePath();
  router.push(localePath({ name: "new", query: { noScroll: "1" } }));
};

const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);
</script>

<style lang="scss" scoped>
.ad {
  margin-bottom: 6rem;
}

.content-wrapper {
  background-color: $light-95;
}
</style>
